<!-- home page top bar -->
<!-- <nav class="navbar navbar-expand-lg navbar-light topmenu" id="mainNav" *ngIf="router.url == '/home'">
    <div class="container-fluid px-4 px-lg-5">
        <a class="navbar-brand" href="javascript:void(0);" [routerLink]="_common.getToken() ? ['/dashboard'] : ['/home']">
            <img class="img-fluid logo" src="assets/img/{{env.host.name}}/logo.png">
        </a>
        <button *ngIf="!_common.getToken()" type="button" class="btn btn-login py-1" (click)="loginRoute()">Login</button>
    </div>
</nav> -->
<!-- home page top bar -->


<div class="navbar-custom">
    <div class="container-fluid">
        <ul class="list-unstyled topnav-menu float-end mb-0">


            <li class="dropdown d-none d-lg-inline-block">
                <form>

                </form>
            </li>

            <li class="dropdown notification-list topbar-dropdown">
                <!-- login form -->
                <!-- <form class="userloginform">
                            <div class="row align-items-center">
                                <div class="col-auto">
                                    <input type="text" class="form-control" id="" placeholder="Username">
                                </div>
                                <div class="col-auto">
                                    <div class="input-group">
                                        <input type="password" class="form-control" id="" placeholder="Passsword">
                                    </div>
                                </div>
                                <div class="col-auto">
                                    <button type="submit" class="btn btnlogin">Login <i class="mdi mdi-logout-variant"></i></button>
                                </div>
                            </div>
                        </form> -->
                <!-- login form -->

                <div class="main-exposure" *ngIf="!isLoggedin">
                    <a href="" class="refresh"><i class="mdi mdi-refresh"></i></a>
                    <a (click)="loginRoute()" class="nav-link nav-user me-0 waves-effect waves-light" href="javascript:void(0)" role="button">
                        <!-- <img src="assets/images/users/user-1.jpg" alt="user-image" class="rounded-circle"> -->
                        <span class="pro-user-name ms-1"> Login
                        </span>
                    </a>
                </div>
                <div class="main-exposure" *ngIf="isLoggedin">
                    <span>Balance {{user?.balance}}</span>
                    <!-- <a href="javascript:void(0)" routerLink="/market-analysis/{{user?.id}}">Exposure (<b [ngClass]="user?.expose >= 0 ? 'profit' : 'loss'">{{user?.expose}}</b>)</a> -->
                    <!-- <a href="" class="refresh"><i class="mdi mdi-refresh"></i></a> -->
                    <!-- <a class="nav-link dropdown-toggle nav-user me-0 waves-effect waves-light" data-bs-toggle="dropdown" href="#" role="button" aria-haspopup="false" aria-expanded="false">
                                <img src="assets/images/users/user-1.jpg" alt="user-image" class="rounded-circle">
                                <span class="pro-user-name ms-1">
                                    <i class="mdi mdi-account"></i> My Account
                                </span>
                            </a> -->
                    <b class="head-username">{{user?.username}}</b>
                    <a class="nav-link dropdown-toggle nav-user me-0 waves-effect waves-light" data-bs-toggle="dropdown"
                        href="#" role="button" aria-haspopup="false" aria-expanded="false">
                        <!-- <img src="assets/images/users/user-1.jpg" alt="user-image" class="rounded-circle"> -->
                        <span class="pro-user-name ms-1">
                            <i class="mdi mdi-account"></i> My Account <i class="mdi mdi-chevron-down"></i>
                        </span>
                    </a>
                    <div class="dropdown-menu dropdown-menu-end profile-dropdown ">
                        <!-- item-->
                        <!-- <div class="dropdown-header noti-title">
                            <h6 class="text-overflow m-0">{{user?.username}}</h6>
                        </div> -->

                        <!-- <a href="javascript:void(0)" routerLink="/profile" class="dropdown-item notify-item">
                            profile
                        </a> -->
                        <!-- <a href="javascript:void(0)" routerLink="/reports/account-statement"
                            class="dropdown-item notify-item">
                            rolling commission
                        </a> -->
                        <!-- <a href="javascript:void(0)" routerLink="/reports/account-statement"
                            class="dropdown-item notify-item">
                            account statement
                        </a>
                        <a href="javascript:void(0)" routerLink="/my-bets" class="dropdown-item notify-item">
                            bets history
                        </a>
                        <a href="javascript:void(0)" routerLink="/reports/profit-loss"
                            class="dropdown-item notify-item">
                            profit/loss
                        </a> -->
                      <a href="javascript:void(0)" routerLink="/my-bets" class="dropdown-item notify-item">
                        bets history
                      </a>
                        <a href="javascript:void(0)" routerLink="/market-analysis/{{user?.id}}" class="dropdown-item notify-item">
                            Market Analysis
                        </a>
                        <a href="javascript:void(0)" routerLink="/change-password" class="dropdown-item notify-item">
                            Change Password
                        </a>
                        <!-- item-->
                        <a href="javascript:void(0)" (click)="logOut()" class="dropdown-item notify-item logout-btn">
                            Logout
                            <i class="fe-log-out"></i>
                        </a>
                    </div>
                </div>
            </li>

            <li class="mobile-section" *ngIf="isLoggedin">
                <div class="mo_user-blnc">
                    <b class="head-username">{{user?.username}}</b>
                    <span> Main <strong>IR {{user?.balance}}</strong></span>
                    <!-- <a href="javascript:void(0)" routerLink="/market-analysis/{{user?.id}}" class="exp-topcount">Exposure
                        <a class="text-white"><strong>(<span [ngClass]="{'loss' : user?.expose < 0, 'profit' : user?.expose > 0}">{{user?.expose}}</span>)</strong></a>
                    </a> -->
                </div>
            </li>
            <!-- <li class="mobile-section">
                <div class="mo_head-refresh">
                    <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink">
                        <defs>
                            <path
                                d="M0 4.004A3.997 3.997 0 0 1 3.998 0h27.004A3.999 3.999 0 0 1 35 4.004v23.992A3.997 3.997 0 0 1 31.002 32H3.998A3.999 3.999 0 0 1 0 27.996V4.004z"
                                id="b" />
                            <filter x="-2.9%" y="-3.1%" width="105.7%" height="106.3%" filterUnits="objectBoundingBox"
                                id="a">
                                <feOffset dy="2" in="SourceAlpha" result="shadowOffsetInner1" />
                                <feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1"
                                    k3="1" result="shadowInnerInner1" />
                                <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
                                    in="shadowInnerInner1" />
                            </filter>
                        </defs>
                        <g fill="none" fill-rule="evenodd">
                            <g transform="translate(-7 -6)">
                                <use fill="%23000" filter="url(%23a)" xlink:href="%23b" />
                                <path stroke="%23BC8C17"
                                    d="M.5 4.004v23.992A3.499 3.499 0 0 0 3.998 31.5h27.004a3.497 3.497 0 0 0 3.498-3.504V4.004A3.499 3.499 0 0 0 31.002.5H3.998A3.497 3.497 0 0 0 .5 4.004z"
                                    stroke-linejoin="square" />
                            </g>
                            <path
                                d="M10 4.029c1.635 0 3.144.36 4.527 1.079 1.365.703 2.443 1.655 3.233 2.854.827 1.247 1.24 2.59 1.24 4.028 0 1.44-.413 2.782-1.24 4.03-.79 1.214-1.868 2.173-3.233 2.877A9.596 9.596 0 0 1 10 20a9.596 9.596 0 0 1-4.527-1.103c-1.365-.704-2.443-1.663-3.233-2.878C1.413 14.772 1 13.43 1 11.99h2.263c0 1.088.301 2.09.903 3.01.602.92 1.42 1.647 2.452 2.182 1.033.536 2.16.804 3.382.804s2.349-.268 3.382-.804c1.033-.535 1.85-1.263 2.452-2.182.602-.92.903-1.922.903-3.01 0-1.087-.301-2.09-.903-3.01-.602-.918-1.42-1.646-2.452-2.181-1.033-.536-2.16-.804-3.382-.804v4.029L4.368 5.012 10 0v4.029z"
                                fill="rgb(255,255,255)" />
                        </g>
                    </svg>
                </div>
            </li> -->
            <!-- <li class="mobile-section">
                <a class="mo_bet-setting" (click)="settingModal.show()">
                    <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink">
                        <defs>
                            <path
                                d="M0 4.004A3.997 3.997 0 0 1 3.998 0h27.004A3.999 3.999 0 0 1 35 4.004v23.992A3.997 3.997 0 0 1 31.002 32H3.998A3.999 3.999 0 0 1 0 27.996V4.004z"
                                id="b" />
                            <filter x="-2.9%" y="-3.1%" width="105.7%" height="106.3%" filterUnits="objectBoundingBox"
                                id="a">
                                <feOffset dy="2" in="SourceAlpha" result="shadowOffsetInner1" />
                                <feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1"
                                    k3="1" result="shadowInnerInner1" />
                                <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
                                    in="shadowInnerInner1" />
                            </filter>
                        </defs>
                        <g fill="none" fill-rule="evenodd">
                            <g transform="translate(-8 -6)">
                                <use fill="%23000" filter="url(%23a)" xlink:href="%23b" />
                                <path stroke="%23BC8C17"
                                    d="M.5 4.004v23.992A3.499 3.499 0 0 0 3.998 31.5h27.004a3.497 3.497 0 0 0 3.498-3.504V4.004A3.499 3.499 0 0 0 31.002.5H3.998A3.497 3.497 0 0 0 .5 4.004z"
                                    stroke-linejoin="square" />
                            </g>
                            <path
                                d="M10.488 13c.621 0 1.203-.16 1.744-.478a3.608 3.608 0 0 0 1.29-1.278A3.32 3.32 0 0 0 14 9.512c0-.621-.16-1.203-.478-1.744a3.578 3.578 0 0 0-1.29-1.29A3.382 3.382 0 0 0 10.488 6a3.32 3.32 0 0 0-1.732.478c-.534.318-.96.748-1.278 1.29A3.382 3.382 0 0 0 7 9.512c0 .621.16 1.198.478 1.732.318.534.744.96 1.278 1.278a3.32 3.32 0 0 0 1.732.478zm7.187-2.014l2.147 1.634c.099.08.157.184.173.313a.555.555 0 0 1-.074.36l-2.073 3.462a.448.448 0 0 1-.26.216.56.56 0 0 1-.357-.024l-2.542-.985c-.658.464-1.242.793-1.752.985l-.37 2.62a.607.607 0 0 1-.185.313.453.453 0 0 1-.309.12H7.927a.485.485 0 0 1-.469-.433l-.395-2.62c-.69-.272-1.267-.6-1.727-.985l-2.567.985c-.263.112-.469.048-.617-.192L.079 13.293a.555.555 0 0 1-.074-.36.464.464 0 0 1 .173-.313l2.171-1.634A7.323 7.323 0 0 1 2.3 10c0-.433.017-.761.05-.986L.177 7.38a.464.464 0 0 1-.173-.313.555.555 0 0 1 .074-.36l2.073-3.462c.148-.24.354-.304.617-.192l2.567.985a8.02 8.02 0 0 1 1.727-.985l.395-2.62A.485.485 0 0 1 7.927 0h4.146c.115 0 .218.04.309.12.09.08.152.184.185.313l.37 2.62c.641.24 1.226.569 1.752.985l2.542-.985a.56.56 0 0 1 .358-.024.448.448 0 0 1 .259.216l2.073 3.462c.066.112.09.232.074.36a.464.464 0 0 1-.173.313l-2.147 1.634c.033.225.05.553.05.986 0 .433-.017.761-.05.986z"
                                fill="rgb(255,255,255)" />
                        </g>
                    </svg>
                </a>
            </li> -->
        </ul>

        <!-- LOGO -->
        <div class="logo-box">
            <a href="javascript:void(0);" [routerLink]="_common.getToken() ? ['/dashboard'] : ['/login']" class="logo logo-light text-center">
                <span class="logo-sm">
                    <img src="/assets/img/{{env.host.name}}/logo.png" alt="" height="22">
                </span>
                <span class="logo-lg">
                    <img class="img-fluid" src="/assets/img/{{env.host.name}}/logo.png" alt="">
                </span>
            </a>
        </div>
        <!-- <div class="bets-mbl-show">
            <a class="open_bets" href="javascript:void(0)" (click)="openModal(openBets)">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                    <path fill="rgb(255,255,255)" fill-rule="nonzero"
                        d="M19.314 6.38c-.41-1.052-.987-2.018-1.708-2.862-1.49-1.75-3.574-2.97-5.94-3.368C11.125.06 10.57 0 10 0c-.57 0-1.124.06-1.667.15-2.365.398-4.447 1.62-5.94 3.367-.72.845-1.297 1.81-1.707 2.863C.25 7.504 0 8.722 0 10c0 1.175.213 2.297.585 3.344.38 1.066.927 2.05 1.62 2.914 1.503 1.868 3.662 3.178 6.128 3.592.543.09 1.098.15 1.667.15.57 0 1.124-.06 1.667-.15 2.466-.414 4.625-1.724 6.127-3.592.694-.864 1.242-1.848 1.62-2.913.373-1.047.586-2.17.586-3.345 0-1.278-.25-2.496-.686-3.62zm-1.173.678l-1.747 1.01c-.332-1.095-.937-2.07-1.735-2.848l1.764-1.02c.746.826 1.333 1.793 1.72 2.858zM15.348 10c0 2.948-2.398 5.347-5.347 5.347-2.95 0-5.347-2.4-5.347-5.347 0-2.948 2.398-5.347 5.347-5.347 2.95 0 5.347 2.4 5.347 5.347zM10 1.333c.57 0 1.127.06 1.667.165v2.04c-.534-.137-1.09-.218-1.667-.218-.576 0-1.133.08-1.667.22V1.497c.54-.106 1.097-.165 1.667-.165zM3.578 4.2l1.765 1.02c-.8.778-1.404 1.753-1.736 2.847L1.86 7.057c.385-1.065.973-2.03 1.718-2.856zm-1.82 8.467l1.775-1.024c.282 1.112.84 2.11 1.604 2.923L3.38 15.58c-.717-.848-1.272-1.834-1.622-2.913zm8.242 6c-.57 0-1.127-.06-1.667-.165v-2.04c.534.137 1.09.218 1.667.218.576 0 1.133-.08 1.667-.22v2.042c-.54.106-1.097.165-1.667.165zm6.62-3.087l-1.757-1.014c.763-.81 1.322-1.81 1.604-2.923l1.775 1.025c-.35 1.078-.905 2.064-1.622 2.912zm-6.003-6.325c1.174.418 1.647.966 1.647 1.862 0 .887-.62 1.644-1.755 1.843v.514c0 .27-.218.488-.485.488s-.483-.218-.483-.488v-.444c-.39-.018-.772-.088-1.098-.187-.332-.1-.526-.448-.44-.787l.005-.017c.035-.145.13-.265.258-.335.13-.07.28-.08.42-.03.328.117.708.2 1.11.2.563 0 .947-.22.947-.618 0-.38-.315-.618-1.045-.867-1.056-.358-1.775-.856-1.775-1.822 0-.877.61-1.564 1.667-1.773v-.458c0-.285.24-.513.53-.486.25.025.436.247.436.5v.375c.347.016.634.062.875.125.315.082.504.406.423.723l-.01.034c-.034.14-.124.258-.248.328s-.27.086-.407.043c-.238-.075-.538-.137-.908-.137-.642 0-.848.28-.848.56 0 .327.344.536 1.183.855z" />
                </svg>
                &nbsp; Bets
            </a>
        </div> -->



        <ul class="list-unstyled topnav-menu topnav-menu-left m-0">

            <li>
                <!-- Mobile menu toggle (Horizontal Layout)-->
                <a class="navbar-toggle nav-link" data-bs-toggle="collapse" data-bs-target="#topnav-menu-content">
                    <div class="lines">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </a>
                <!-- End mobile menu toggle-->
            </li>

            <li class="d-none d-xl-block">
                <form class="app-search">
                    <div class="app-search-box">
                        <div class="input-group">
                            <button class="btn input-group-text px-1" type="submit">
                                <i class="mdi mdi-search-web"></i>
                            </button>
                            <input type="text" class="form-control" placeholder="Search Events" [(ngModel)]="selected"
                                [ngModelOptions]="{standalone: true}" [typeahead]="searchData"
                                [typeaheadItemTemplate]="customItemTemplate" [typeaheadScrollable]="true"
                                [typeaheadOptionsInScrollableView]="5" typeaheadOptionField="name"
                                (typeaheadOnSelect)="redirectDetail($event)">

                            <ng-template #customItemTemplate let-model="item" let-index="index">
                                <a *ngIf="isLoggedin" href="javascript:void(0);" id="menu-link-redi"
                                    routerLink="/event/detail/{{model.event_id}}" class="searchAnchor">
                                    {{model.name}}
                                </a>
                                <a *ngIf="!isLoggedin" href="javascript:void(0);" id="menu-link-redi"
                                    routerLink="/guest/event/detail/{{model.event_id}}" class="searchAnchor">
                                    {{model.name}}
                                </a>
                            </ng-template>
                        </div>
                        <div class="dropdown-menu dropdown-lg" id="search-dropdown">
                            <!-- item-->
                            <div class="dropdown-header noti-title">
                                <h5 class="text-overflow mb-2">Found 22 results</h5>
                            </div>

                            <!-- item-->
                            <a href="javascript:void(0);" class="dropdown-item notify-item">
                                <i class="fe-home me-1"></i>
                                <span>Analytics Report</span>
                            </a>

                            <!-- item-->
                            <a href="javascript:void(0);" class="dropdown-item notify-item">
                                <i class="fe-aperture me-1"></i>
                                <span>How can I help you?</span>
                            </a>

                            <!-- item-->
                            <a href="javascript:void(0);" class="dropdown-item notify-item">
                                <i class="fe-settings me-1"></i>
                                <span>User profile settings</span>
                            </a>

                            <!-- item-->
                            <div class="dropdown-header noti-title">
                                <h6 class="text-overflow mb-2 text-uppercase">Users</h6>
                            </div>

                            <div class="notification-list">
                                <!-- item-->
                                <a href="javascript:void(0);" class="dropdown-item notify-item">
                                    <div class="d-flex align-items-start">
                                        <img class="d-flex me-2 rounded-circle" src="assets/images/users/user-2.jpg"
                                            alt="Generic placeholder image" height="32">
                                        <div class="w-100">
                                            <h5 class="m-0 font-14">Erwin E. Brown</h5>
                                            <span class="font-12 mb-0">UI Designer</span>
                                        </div>
                                    </div>
                                </a>

                                <!-- item-->
                                <a href="javascript:void(0);" class="dropdown-item notify-item">
                                    <div class="d-flex align-items-start">
                                        <img class="d-flex me-2 rounded-circle" src="assets/images/users/user-5.jpg"
                                            alt="Generic placeholder image" height="32">
                                        <div class="w-100">
                                            <h5 class="m-0 font-14">Jacob Deo</h5>
                                            <span class="font-12 mb-0">Developer</span>
                                        </div>
                                    </div>
                                </a>
                            </div>

                        </div>
                    </div>
                </form>
            </li>
        </ul>
        <div class="clearfix"></div>
    </div>
</div>
<div class="topnav" *ngIf="router.url != '/home'">
    <div class="container-fluid">
        <nav class="navbar navbar-light navbar-expand-lg topnav-menu">

            <div class="collapse navbar-collapse" id="topnav-menu-content">
                <ul class="navbar-nav">
                    <li class="nav-item">
                        <a href="javascript:void(0)" [routerLink]="_common.getToken() ? ['/dashboard'] : ['/guest/dashboard']" routerLinkActive="active">home</a>
                    </li>
                    <li class="nav-item">
                        <a href="javascript:void(0)" [routerLink]="_common.getToken() ? ['/inplay'] : ['/guest/inplay']" routerLinkActive="active">in-play</a>
                    </li>
                    <!-- <li class="nav-item">
                        <a href="">multi markets</a>
                    </li> -->
                    <li class="nav-item" *ngFor="let item of menu;">
                        <a href="javascript:void(0)" [routerLink]="_common.getToken() ? ['/sports',item?.id] : ['/guest/sports',item?.id]"
                            routerLinkActive="active">{{item?.name}}</a>
                    </li>
                </ul> <!-- end navbar-->

                <a *ngIf="_common.getToken()"  href="javascript:void(0);" class="multi-market cogSetting" routerLink="/multi-market">
                    Multi Market
                </a>
                <!-- <a *ngIf="_common.getToken()" href="javascript:;" class="cogSetting" data-bs-toggle="collapse" href="#collapseSetting">
                    Setting <i class="mdi mdi-cog"></i>
                </a> -->
            </div> <!-- end .collapsed-->
        </nav>

    </div> <!-- end container-fluid -->
</div>




<div class="modal fade" bsModal #login="bs-modal" [config]="{backdrop: true}" tabindex="-1" role="dialog"
    aria-labelledby="dialog-static-name">
    <div class="modal-dialog login-modal modal-ui">
        <div class="modal-content">
            <div class="modal-header">
                <!-- <h5 class="modal-title pull-left" id="">Login</h5> -->
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="login.hide()">
                    <i class="mdi mdi-close"></i>
                </button>
            </div>
            <div class="modal-body">
                <app-login (closeLogin)="closeModal()" (forceChangePwd)="openAppMoadal(changePwd)"></app-login>
            </div>
        </div>
    </div>
</div>

<ng-template #changePwd>
    <div class="modal-header">
        <h5 class="modal-title pull-left" id="">Change Password</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modalRef!.hide()">
            <i class="fa fa-close"></i>
        </button>
    </div>
    <div class="modal-body">
        <app-change-password class="modal-change-pwd" (openLogin)="loginRoute()" [isModal]="true">
        </app-change-password>
        <!-- <app-login (forceChangePwd)="forceChangePwd()"></app-login> -->
    </div>
</ng-template>

